import ColourBox from './ColourBox.vue';
import ColourPicker from './ColourPicker.vue';
import ColourRangeSlider from './ColourRangeSlider.vue';

export default [
  ColourPicker,
  ColourBox,
  ColourRangeSlider,
];
